import React from "react";

function Roadmap() {
  return <div>Roadmap</div>;
}

export default Roadmap;
